import React from 'react';
import { CheckIcon } from 'lucide-react';
interface StepIndicatorProps {
  currentStep: number;
}
export const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep
}) => {
  const steps = [{
    number: 1,
    title: 'Collection Details'
  }, {
    number: 2,
    title: 'Add Products'
  }, {
    number: 3,
    title: 'Review & Create'
  }];
  return <div className="px-6 py-4 border-b border-gray-200" data-id="element-420">
      <div className="flex items-center" data-id="element-421">
        <div className="w-full bg-gray-200 h-1.5 rounded-full overflow-hidden" data-id="element-422">
          <div className="bg-blue-600 h-full transition-all duration-300 ease-in-out" style={{
          width: `${(currentStep - 1) / (steps.length - 1) * 100}%`
        }} data-id="element-423"></div>
        </div>
      </div>
      <div className="flex justify-between mt-2" data-id="element-424">
        {steps.map(step => <div key={step.number} className="flex flex-col items-center relative" style={{
        width: `${100 / steps.length}%`
      }} data-id="element-425">
            <div className={`h-8 w-8 rounded-full flex items-center justify-center ${step.number < currentStep ? 'bg-blue-600 text-white' : step.number === currentStep ? 'bg-blue-100 border-2 border-blue-600 text-blue-600' : 'bg-gray-100 text-gray-400 border border-gray-300'} mb-1`} data-id="element-426">
              {step.number < currentStep ? <CheckIcon className="h-4 w-4" data-id="element-427" /> : step.number}
            </div>
            <span className={`text-xs ${step.number === currentStep ? 'text-blue-600 font-medium' : 'text-gray-500'}`} data-id="element-428">
              {step.title}
            </span>
          </div>)}
      </div>
    </div>;
};